import { BrandLogo } from '@calendly/ui/components/brand-logo';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
const containerSizeSmallCss = "cuctcv8";
const containerSizeStandardCss = "c19okhdi";
const containerSizeLargeCss = "c1tfgcur";
const containerSizeXlargeCss = "c3l7yhe";
const containerCss = "c1ngvmau";
const Container = forwardRef((props, ref) => {
  const {
    size,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, {
    [containerSizeSmallCss]: size?.toString() === 'small',
    [containerSizeStandardCss]: size?.toString() === 'standard',
    [containerSizeLargeCss]: size?.toString() === 'large',
    [containerSizeXlargeCss]: size?.toString() === 'xlarge'
  }, props.className)} />;
});
const wrapperCss = "w19rixz8";
const Wrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, props.className)} />;
});
const providerMap = {
  google: 'google-calendar',
  outlook: 'microsoft-outlook-calendar',
  office365: 'microsoft-office',
  icloud: 'icloud',
  outlook_desktop: 'microsoft-outlook-calendar',
  exchange: 'microsoft-exchange'
};
export const ProviderIcon = ({
  provider,
  size = 'standard'
}) => {
  const logoName = providerMap[provider];
  return <Container size={size}>
      <Wrapper>
        <BrandLogo name={logoName} />
      </Wrapper>
    </Container>;
};
ProviderIcon.propTypes = {
  provider: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['small', 'standard', 'large', 'xlarge'])
};

require("./provider_icon.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./provider_icon.js");